var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ytt-loader",class:{ 'ytt-loader_show': _vm.show }},[_c('div',{staticClass:"ytt-loader__wrap"},[_c('svg',{directives:[{name:"svg",rawName:"v-svg"}],staticClass:"ytt-loader__icon",attrs:{"symbol":"icon-loader","size":"0 0 72 72"}}),_c('div',{staticClass:"ytt-loader__text"},[_vm._v("\n      loading\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }